export const routes = {
  index: '/',
  zendeskHome: '/zendesk/home',
  preview: '/v1/api/preview/*',
  error: '/error',
}
